<template>
  <sui-modal v-model="modalOpen">
    <sui-modal-header>Add a new class</sui-modal-header>
    <sui-modal-content class="scrolling">
      <class-form
        v-bind:group="newClass"
        v-on:saved="classSaved"
        v-bind:error="newClassError"
        create="true"
        ref="newClassForm"
      />
    </sui-modal-content>
    <sui-modal-actions>
      <sui-button negative v-on:click="hideCreateModal"> Cancel </sui-button>
    </sui-modal-actions>
  </sui-modal>
</template>

<script>
import ClassForm from '@/components/classes/ClassForm';
import { mapGetters } from 'vuex';

export default {
  name: 'AddClassModal',
  components: { ClassForm },
  computed: {
    ...mapGetters({
      addClassModalOpen: 'addClassModalOpen',
    }),
    modalOpen: {
      get() {
        return this.addClassModalOpen;
      },
      set(isOpen) {
        this.hideCreateModal();
        return isOpen;
      },
    },
  },
  data() {
    return {
      newClassError: null,
      newClass: {
        Name: '',
        Start: '',
        End: '',
      },
    };
  },
  watch: {
    addClassModalOpen(val) {
      if (val) {
        this.newClass = {
          Name: null,
          Start: null,
          End: null,
        };
        this.newClassError = null;
        this.$refs.newClassForm.reset();
      }
    },
  },
  methods: {
    hideCreateModal() {
      this.$store.dispatch('hideAddClassModal');
    },
    classSaved() {
      this.$store.dispatch('createClass', this.newClass).then(
        () => {
          this.hideCreateModal();
        },
        (error) => {
          this.newClassError = error.response.data;
        },
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/classes/AddClassModal.vue